module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAAS5JREFUOE/tlb9KxEAQxr9BDNpbWFicoOlSpdHXsNQmghvPNxCuUAvBNxBmLxrI1T6FhY9gIRjQFxAUQjB8EkkgHhfxcv5p3GZ3mZ3fzsx+zAq+eUgbLwzDJQCW5HLzjIg8ADCq+jTJ9zPgAcktkqdjwIGIXKnq+bTAI5I9a+1u09EYcykiqaqe/C7Q9/15z/PmylvTNH11XXfQOUJjzEhEdhopHJfrzsAwDFkUxXoURXd1jWYG5nm+Gsdx+mdAACOSa3WZsiy7TpLk5V2HZcrTRliB+iRvASyUe2vt5kzA+tGCIOg5jnOvqvIP/Lpsmjr9+RoaY54B7AN4FJFDADeVLDZIno21r0n2FREZqupi/crbJPsi4lTOw2rea2nAH+wkcwAX1tq4tcF2/RneALzccCQqdqgeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/index/images/appIcon/normal_sj.png
// module id = hL2r
// module chunks = 57